import axios from 'axios';

export default class ApiService{
    constructor(){
        this.api_url = '';

        if( window.communiti_api_base_url != undefined )
			this.api_url = window.communiti_api_base_url;

		let axios_config = {
			baseURL: this.api_url,
			timeout: 30000,
		};

		if( window.communiti_nonce )
			axios_config.headers = { ...axios_config.headers, 'X-WP-Nonce': window.communiti_nonce }


        this.client =  axios.create(axios_config); 
        
    }
}